export default "__VITE_ASSET__a1508b23__"